// extracted by mini-css-extract-plugin
module.exports = {"operation":"Operation_style_operation__1YVhp","mr20":"Operation_style_mr20__g1WR5","line":"Operation_style_line__yVUBH"};